import React, { useState, useEffect } from "react";
import { texts } from "../../general/texts";
import colors from "../../colors";
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch, useSelector } from "react-redux";
import { sendGeneralRequest } from "../../../features/generalRequest";
import { selectGlobalDataState } from "../../../features/global/globalDataSlice";
import NoReferences from "./NoReferences";
import FriendsList from "./FriendsList";
import { useNavigate } from "react-router-dom";

const References = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const [referedFriends, setReferedFriends] = useState([])

    useEffect(() => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token }, baseUrlKey: 'services', endpoint: 'InviteFriend/GeneratedInvitedCodes' })).then(response => {
            if (response.payload.response.success) {
                setReferedFriends(response.payload.response.confirmedCodes)
            }
        })
    }, []);

    const useStyles = makeStyles({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        flexRow: {
            display: 'flex',
            flexDirection: 'row',
        },

        flexCol: {
            display: 'flex',
            flexDirection: 'column',
        }
    });

    const classes = useStyles();

    return (
        <>
            <div className={classes.container}>
                {(referedFriends.length > 0) ? (
                    <FriendsList list={referedFriends} />
                ) : (
                    <NoReferences />
                )
                }
            </div>
            <div className={classes.flexRow} style={{ justifyContent: 'right', marginTop: '80px', marginRight: isSmallScreen ? '10px' : '350px' }}>
                <span onClick={() => navigate('/inviteFriend/howItWorks')} style={{ color: colors.orange, fontWeight: 700, fontSize: '15px', cursor: 'pointer' }}>{texts['prompt-how-it-works']}</span>
                <span><a href="https://easypay.al/wp-content/uploads/2024/11/Marreveshje%20e%20Programit%20Refero-nj%C3%AB-mik.pdf" target="_blank" style={{ marginLeft: '40px', color: colors.orange, fontSize: '15px', fontWeight: 700, textDecoration: 'none' }}>{texts['title-terms-and-conditions']}</a></span>
            </div>
        </>
    )
}
export default References;